import script from "./ClinicalLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicalLayout.vue?vue&type=script&setup=true&lang=js"

import "./ClinicalLayout.vue?vue&type=style&index=0&id=e5e76000&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5e76000"]])

export default __exports__